<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="onAdd()"
                    matTooltip="{{ 'new_record_hint' | transloco }}"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">

                    <div class="filter-item">
                        <ng-container *transloco="let t">
                            <pixl-free-filter-input
                                [label]="t('name_or_title_or_id')"
                                [matIcon]="'search'"
                                [hint]="getSearchFilterHint()"
                                [minLength]="freeFilterLen"
                                (onKeyUpChange)="setFreeFilter($event)"
                            />
                        </ng-container>
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Anwendungen</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setConsumerFilter($event)"
                            >
                                @for (consumer of consumers$ | async; track consumer) {
                                <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Fächer</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setSubjectFilter($event)"
                            >
                                @for (subject of subjects$ | async; track subject) {
                                <mat-option [value]="subject.name">{{ subject.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <pixl-multi-combo-entity-search
                            [label]="learningUnitLabels"
                            [observable$]="learningUnits$"
                            [namingColumn]="'title'"
                            [externalSearch]="true"
                            (onStateChange)="receiveLearningUnitData($event)"
                            (onSearchChange)="receiveLearningUnitQuery($event)"
                            (scrolledToEnd)="loadMoreLearningUnits($event)"
                            [(selectedValues)]="selectedLearningUnits"
                        >
                        </pixl-multi-combo-entity-search>
                    </div>
                </div>
                <div class="main-toolbar-spacer-right"></div>
            </div>
            <div class="table-header-overlay"></div>
        </div>
    </div>

    <div class="table-container mat-elevation-z4">
        @if (learningSections$ | async; as learningSection) {
        <table
            mat-table
            [dataSource]="learningSection"
            matSort
            [trackBy]="trackById"
            (matSortChange)="announceSortChange($event)"
        >
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "actions" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="onEdit(learningSection)"
                        matTooltip="{{ 'edit_record_hint' | transloco }}"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>

                    <button
                        [class.btn-warning]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit Container"
                        (click)="onEditContainer(learningSection)"
                        matTooltip="{{ 'edit_container_hint' | transloco }}"
                    >
                        <mat-icon>line_style</mat-icon>
                    </button>

                    <button
                        [class.btn-info]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Copy"
                        (click)="onCopy(learningSection)"
                        matTooltip="{{ 'copy_record_hint' | transloco }}"
                    >
                        <mat-icon>content_copy</mat-icon>
                    </button>

                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        color="warn"
                        aria-label="Delete"
                        (click)="onDelete(learningSection)"
                        matTooltip="{{ 'delete_record_hint' | transloco }}"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="id">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >ID</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    {{ learningSection.id }}
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "name" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    {{ learningSection.name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="title">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "title" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    {{ learningSection.title }}
                </td>
            </ng-container>

            <ng-container matColumnDef="learningSectionType">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "type" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    {{ learningSection.learningSectionType }}
                </td>
            </ng-container>

            <ng-container matColumnDef="consumer">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "consumer" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    @if (learningSection.consumer?.id; as consumerId) {
                    <span class="badge badge-dark me-1">
                        {{ getConsumerName(consumerId) }}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="subjects">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "subjects_professions" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    @for (subjectName of getSubjectNames(learningSection.subjects); track subjectName) {
                    <span class="badge badge-dark me-1">
                        {{ subjectName }}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="learningUnits">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "learning_units" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    @for (unitName of getLearningUnitNames(learningSection.learningUnits); track $index) {
                    <span class="badge badge-dark me-1">
                        {{ unitName }}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="learningSectionLayout">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >Layout</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    {{ learningSection.learningSectionLayout?.name }}
                    {{ learningSection.learningSectionLayout?.id &&
                    getLearningSectionLayoutName(learningSection.learningSectionLayout.id) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="is_mandatory">
                <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                >{{ "is_mandatory" | transloco }}</th>
                <td
                        mat-cell
                        *matCellDef="let learningSection"
                >
                    @if (learningSection.is_mandatory) {
                        <span class="badge badge-danger">{{ "mandatory" | transloco }}</span>
                    } @else {
                        <span class="badge badge-success">{{ "voluntary" | transloco }}</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="showCopyright">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >Copyright</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    @if (learningSection.showCopyright) {
                    <span class="badge badge-success">{{ "active" | transloco }}</span>
                    } @else {
                    <span class="badge badge-danger">{{ "inactive" | transloco }}</span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="version">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >Version</th>
                <td
                    mat-cell
                    *matCellDef="let learningSection"
                >
                    {{ learningSection.version }}
                </td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.selected-row]="currentSelectedRow() === row.id"
            ></tr>
        </table>
        } @else {
        <pixl-table-loading-spinner [name]="'Lernabschnitte'" />
        }
        <mat-paginator
            [pageIndex]="pageChange().pageIndex"
            [pageSize]="pageChange().pageSize"
            [pageSizeOptions]="[25, 50, 100]"
            [length]="totalItems">
        </mat-paginator>
    </div>
</div>